import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import { motion } from 'motion/react';
import { useEffect, useState } from 'react';

import { Markdown } from '~components/Markdown';
import ToggleIcon from '~public/static/images/icons/plus_icon.svg';

import styles from './Accordion.module.scss';
import { AccordionProps } from './Accordion.types';

export function Accordion({ text, title, className }: AccordionProps) {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [hasLayout, setHasLayout] = useState<boolean>(false);

  useEffect(() => {
    if (isActive) {
      setHasLayout(true);
    }
  }, [isActive]);

  function handleToggle() {
    setIsActive((prev) => !prev);
  }
  return (
    <div className={styles.accordionItem}>
      <div
        className={classNames(styles.accordionHead, className)}
        onClick={handleToggle}
      >
        <Typography mods={[TypographyMods.titleS]} tagName={TypographySizes.h3}>
          {title}
        </Typography>
        <ToggleIcon
          className={classNames(styles.toggle, {
            [styles.toggleActive]: isActive,
          })}
        />
      </div>
      <motion.div
        initial={false}
        animate={{
          height: isActive ? 'auto' : 0,
        }}
        transition={{
          type: 'spring',
          duration: 0.5,
          bounce: 0,
        }}
        className={classNames(styles.content, {
          [styles.outOfLayout]: !isActive && !hasLayout,
        })}
        onAnimationComplete={() => {
          if (!isActive) {
            setHasLayout(false);
          }
        }}
      >
        <Typography tagName={TypographySizes.div} mods={[TypographyMods.bodyS]}>
          <Markdown className={styles.body}>{text}</Markdown>
        </Typography>
      </motion.div>
    </div>
  );
}
